import React from 'react';
import { connect } from 'react-redux';
import { List, ListItem } from 'material-ui';
import {
  showNotification as showNotificationAction,
  translate as t,
  Restricted,
} from 'admin-on-rest';
import { groupBy, get } from 'lodash';
import moment from 'moment';

import Section from '../utils/Section';
import References from '../References';
import TranslationComponent from './TranslationComponent';

const missingTranslations = (props, property) => {
  const filterFn = props.filter
    ? (item) =>
      item[Object.keys(props.filter)[0]] ===
        props.filter[Object.keys(props.filter)[0]]
    : (item) => !!item;

  return props.choices[props.resource]
    .filter(filterFn)
    .reduce(
      (sum, resource) =>
        sum +
        resource[property].reduce(
          (s, p) =>
            !p ||
            (props.user.languages &&
              props.user.languages.includes(p.lang) &&
              (!p || (p && !p.content)))
              ? s + 1
              : s,
          0
        ),
      0
    );
};

const MissingTranslationCount = (props) => {
  let missing;
  missing = missingTranslations(props, props.property);
  if (props.properties) {
    missing = props.properties
      .map((property) => missingTranslations(props, property))
      .reduce((acc, next) => next + acc, 0);
  }
  return (
    <div className="missing-translation-text">
      {`${missing} ${props.translate('missingTranslations', {
        smart_count: missing,
      })}`}
    </div>
  );
};

const LastUpdated = (props) => {
  const filterFn = props.filter
    ? (item) =>
      item[Object.keys(props.filter)[0]] ===
        props.filter[Object.keys(props.filter)[0]]
    : (item) => !!item;

  const lastUpdated = props.choices[props.resource]
    .filter(filterFn)
    .reduce(
      (acc, current) =>
        acc.length === 0
          ? current
          : acc.updatedAt.valueOf() > current.updatedAt.valueOf()
            ? acc
            : current,
      []
    );
  return (
    <div className="missing-translation-text">
      {props.translate('updated')}:{' '}
      {moment(lastUpdated.updatedAt).format('YYYY-MM-DD, HH:mm')}
    </div>
  );
};

const productsByMarket = (props) => {
  const products = get(props, 'choices.products', []);
  const result = {};
  products.forEach((product) => {
    const mrkt = product.markets.find((m) => m.suggestedPrice > 0);
    if (mrkt) {
      if (get(result, mrkt.countryCode)) {
        result[mrkt.countryCode].push(product);
      } else {
        result[mrkt.countryCode] = [];
        result[mrkt.countryCode].push(product);
      }
    }
  });
  return result;
};

const Translations = (props) => {
  const groupedByPlatform =
    Object.keys(groupBy(props.choices.phrases, 'platform')).length > 0
      ? { android: {}, ios: {}, ...groupBy(props.choices.phrases, 'platform') }
      : { android: {}, ios: {} };
  const productsByMrkt = productsByMarket(props);
  return (
    <Section title="translations">
      <List>
        <ListItem
          primaryText={props.translate('resources.products.name', {
            smart_count: 2,
          })}
          primaryTogglesNestedList
          nestedItems={Object.keys(productsByMrkt).map((mrkt) => (
            <ListItem
              primaryText={props.translate(`translations.${mrkt}`)}
              secondaryText={
                <MissingTranslationCount
                  {...props}
                  choices={{
                    ...props.choices,
                    products: get(productsByMrkt, mrkt, props.choices.products),
                  }}
                  resource="products"
                  property="title"
                  properties={['title', 'subtitle']}
                />
              }
              primaryTogglesNestedList
              nestedItems={[
                <ListItem
                  primaryText={props.translate(
                    'resources.products.fields.title'
                  )}
                  secondaryText={
                    <React.Fragment>
                      <MissingTranslationCount
                        {...props}
                        choices={{
                          ...props.choices,
                          products: get(
                            productsByMrkt,
                            mrkt,
                            props.choices.products
                          ),
                        }}
                        resource="products"
                        property="title"
                      />
                      <LastUpdated
                        {...props}
                        choices={{
                          ...props.choices,
                          products: get(
                            productsByMrkt,
                            mrkt,
                            props.choices.products
                          ),
                        }}
                        resource="products"
                        property="title"
                      />
                    </React.Fragment>
                  }
                  primaryTogglesNestedList
                  nestedItems={[
                    <TranslationComponent
                      {...props}
                      choices={{
                        ...props.choices,
                        products: get(
                          productsByMrkt,
                          mrkt,
                          props.choices.products
                        ),
                      }}
                      key="products"
                      resource="products"
                      property="title"
                      showTitle
                      type="textarea"
                    />,
                  ]}
                />,
                <ListItem
                  primaryText={props.translate(
                    'resources.products.fields.subtitle'
                  )}
                  secondaryText={
                    <React.Fragment>
                      <MissingTranslationCount
                        {...props}
                        choices={{
                          ...props.choices,
                          products: get(
                            productsByMrkt,
                            mrkt,
                            props.choices.products
                          ),
                        }}
                        resource="products"
                        property="subtitle"
                      />
                      <LastUpdated
                        {...props}
                        choices={{
                          ...props.choices,
                          products: get(
                            productsByMrkt,
                            mrkt,
                            props.choices.products
                          ),
                        }}
                        resource="products"
                        property="subtitle"
                      />
                    </React.Fragment>
                  }
                  primaryTogglesNestedList
                  nestedItems={[
                    <TranslationComponent
                      {...props}
                      choices={{
                        ...props.choices,
                        products: get(
                          productsByMrkt,
                          mrkt,
                          props.choices.products
                        ),
                      }}
                      key="products"
                      resource="products"
                      property="subtitle"
                      showTitle
                      type="textarea"
                    />,
                  ]}
                />,
              ]}
            />
          ))}
        />
        <ListItem
          primaryText={props.translate('resources.allergens.name', {
            smart_count: 2,
          })}
          secondaryText={
            <MissingTranslationCount
              {...props}
              resource="allergens"
              property="title"
            />
          }
          primaryTogglesNestedList
          nestedItems={[
            <TranslationComponent
              {...props}
              key="allergens"
              resource="allergens"
              property="title"
            />,
          ]}
        />
        <ListItem
          primaryText={props.translate('resources.diets.name', {
            smart_count: 2,
          })}
          secondaryText={
            <MissingTranslationCount
              {...props}
              resource="diets"
              property="title"
            />
          }
          primaryTogglesNestedList
          nestedItems={[
            <TranslationComponent
              {...props}
              key="diets"
              resource="diets"
              property="title"
            />,
          ]}
        />
        <ListItem
          primaryText={props.translate('resources.categories.name', {
            smart_count: 2,
          })}
          secondaryText={
            <MissingTranslationCount
              {...props}
              resource="categories"
              property="title"
            />
          }
          primaryTogglesNestedList
          nestedItems={[
            <TranslationComponent
              {...props}
              key="categories"
              resource="categories"
              property="title"
            />,
          ]}
        />
        {/* <ListItem
          primaryText={props.translate('resources.phrases.name', { smart_count: 2 })}
          secondaryText={<MissingTranslationCount {...props} resource="phrases" property="translations" />}
          primaryTogglesNestedList
          nestedItems={[
            <TranslationComponent {...props} key="phrases" resource="phrases" property="translations" />,
          ]}
        /> */}

        {Object.keys(groupedByPlatform).map((platform) => (
          <ListItem
            // primaryText={props.translate('resources.phrases.name', { smart_count: 2 })}
            secondaryText={
              <React.Fragment>
                <MissingTranslationCount
                  {...props}
                  filter={{ platform }}
                  resource="phrases"
                  property="translations"
                />
                <LastUpdated
                  {...props}
                  resource="phrases"
                  filter={{ platform }}
                  property="translations"
                />
              </React.Fragment>
            }
            primaryText={platform}
            primaryTogglesNestedList
            nestedItems={[
              <TranslationComponent
                {...props}
                key="phrases"
                resource="phrases"
                filter={{ platform }}
                property="translations"
              />,
            ]}
          />
        ))}
      </List>
    </Section>
  );
};

const Translation = (props) => (
  <Restricted
    authParams={{ route: '/academy-viewer/courses' }}
    location={props.location}
  >
    <References
      references={[
        { name: 'categories' },
        { name: 'diets' },
        { name: 'allergens' },
        {
          name: 'products',
          filter: { provisional: { $ne: true }, frozen: { $ne: true } },
        },
        { name: 'phrases', filter: { platform: { $exists: true } } },
      ]}
      {...props}
    >
      <Translations {...props} />
    </References>
  </Restricted>
);

export default connect((state) => state, {
  showNotification: showNotificationAction,
})(t(Translation));
